<div [class.bl-disabled]="!field.enabled" [ngClass]="formatter">
  <label [id]="field.id + '-label'" class="bl-label bl-font-weight--800 bl-font-size--14" [class.bl-screen-reader-only]="screenReaderOnly(field)" [for]="field.id" [class.bl-required]="field.required">
    {{ field.label }}
    <button *ngIf="tooltip" type="button" aria-label="tooltip" class="bl-font-color--blue bl-margin-left--4">
      <i class="cu-info-circle" eaTooltip="{{ tooltip }}"></i>
      <span class="bl-screen-reader-only">{{ tooltip }}</span>
    </button>
  </label>

  <input
    [type]="inputType"
    [autocomplete]="inputAutocomplete"
    [attr.aria-describedby]="field.id + '-desc-container'"
    [attr.aria-labelledby]="fieldLabelledBy"
    class="bl-form-input bl-input"
    [class.bl-disabled]="!field.enabled"
    [required]="field.required"
    #input
    [attr.inputmode]="field.inputMode"
    [cuFieldState]="field"
    [disabled]="!field.enabled"
    [id]="field.id"
    [maxlength]="field.fieldMaxLength"
    [attr.data-automation-id]="field.automationId"
    [placeholder]="field.config.placeholder || ''"
    [(ngModel)]="maskedValue"
    (input)="processMask()"
    (blur)="doBlur()"
    (focus)="doFocus()"
    (keydown)="handleKeydown($event)"
    (keypress)="blockSpecialChar($event)"
  />
</div>
